<template>
    <section>
        <div id="cliente-section">
            <div id="sessao_dados_do_cliente">
                <div class='row' id="Empresa">
                    <div class="col-xs-12">
                        <h3><icon name="male"></icon> Dados da empresa</h3>
                    </div>
                </div>

                <div class='row'>
                    <div class='col-xs-12 col-md-3'>
                        <div class="form-group" :class="{ 'has-error': errors.has('data.customer.document') }">
                            <label for="data.customer.document">CNPJ <span class="text-danger">*</span></label>
                            <input type="text" class="form-control update-driver" id="data.customer.document" name="data.customer.document" v-mask="['XX.XXX.XXX/XXXX-##']" data-vv-as="CNPJ" v-validate="{ rules: { required: true, regex: /^([A-Za-z0-9]{2}.[A-Za-z0-9]{3}.[A-Za-z0-9]{3}\/[A-Za-z0-9]{4}-\d{2})$/ } }" v-model="customer.document" />
                            <div class="error-message" v-if="errors.has('data.customer.document')">{{ errors.first('data.customer.document') }}</div>
                        </div>
                    </div>
                    <div class='col-xs-12 col-md-9'>
                        <div class="form-group" :class="{ 'has-error': errors.has('data.customer.name') }">
                            <label for="data.customer.name">Razão Social <span class="text-danger">*</span></label>
                            <input type="text" class="form-control update-driver" id="data.customer.name" name="data.customer.name" v-validate="{ rules: { required: true } }" data-vv-as="Razão Social" v-model="customer.name" @input="$emit('update:modelValue', $event.target.value)"/>
                            <div class="error-message" v-if="errors.has('data.customer.name')">{{ errors.first('data.customer.name') }}</div>
                        </div>
                    </div>
                </div>

                <div class='row'>
                    <div class='col-xs-12 col-md-6' >
                        <div class="form-group" :class="{ 'has-error': errors.has('data.customer.email') }">
                            <label for="data.customer.email">E-mail <span class="text-danger" v-if="contactValidate">*</span></label>
                            <input type="text" class="form-control" id="data.customer.email" name="data.customer.email" v-validate="{ rules: { required: contactValidate, email: true } }" data-vv-as="E-mail" v-model="customer.email" />
                            <div class="error-message" v-if="errors.has('data.customer.email')">{{ errors.first('data.customer.email') }}</div>
                        </div>
                    </div>

                    <div class='col-xs-12 col-md-3'>
                        <div class="form-group" :class="{ 'has-error': errors.has('data.customer.phone') }">
                            <label for="ata[customer][phone]">Telefone <span class="text-danger" v-if="contactValidate">*</span></label>
                            <input type="text" class="form-control" id="ata[customer][phone]" name="data.customer.phone" v-validate="{ rules: { required: contactValidate, regex: /^(\(\d{2}\) \d{4}-\d{4}|\(\d{2}\) \d{5}-\d{4})$/ } }" data-vv-as="Telefone" v-mask="['(##) ####-####', '(##) #####-####']" v-model="customer.phone" />
                            <div class="error-message" v-if="errors.has('data.customer.phone')">{{ errors.first('data.customer.phone') }}</div>
                        </div>
                    </div>

                    <div class='col-xs-12 col-md-3'>
                        <div class="form-group" :class="{ 'has-error': errors.has('data.customer.celphone') }">
                            <label for="data.customer.celphone">Celular para contato </label>
                            <input type="text" class="form-control" id="data.customer.celphone" name="data.customer.celphone" data-vv-as="Celular para contato" v-mask="['(##) ####-####', '(##) #####-####']" v-model="customer.celphone" />
                            <div class="error-message" v-if="errors.has('data.customer.celphone')">{{ errors.first('data.customer.celphone') }}</div>
                        </div>
                    </div>                    
                </div>

                  <!--Checkbox-->
                <div class='row' v-if="!showFormCustomer">
                    <div class='col-xs-12'>
                        <div class="form-group" :class="{ 'has-error': errors.has('chkConsentimento') }">

                                <label for="chkConsentimento" >
                                    <input type="checkbox" id="chkConsentimento" name="chkConsentimento" data-vv-as="check de consentimento" v-validate="{ rules: { required: true } }"> 
                                    Declaro que solicitei a prévia autorização para utilização dos dados do titular conforme a base legal prevista no artigo 7°, inciso V, da LGPD. <a href="https://www.segfy.com/termos-de-uso/" target="_blank">Ler Política de Privacidade</a>
                                </label>  
                                <div class="error-message" v-if="errors.has('chkConsentimento')">{{ errors.first('chkConsentimento') }}</div>
                        </div>
                    </div>
                </div>

                <div class='row' v-if="showFormCustomer">
                    <div class='col-xs-12'>
                        <div class="form-group" :class="{ 'has-error': errors.has('chkConsentimento2') }">

                                <label for="chkConsentimento2"  >
                                    <input type="checkbox" id="chkConsentimento2" name="chkConsentimento2" data-vv-as="check de consentimento" v-validate="{ rules: { required: true } }"> Eu autorizo que sejam tomadas decisões referentes ao tratamento de meus dados pessoais, bem como seja realizado o devido tratamento envolvendo
                                    operações como as que se referem a coleta, a utilização, o processamento, e o controle da informação para a cotação de meu seguro. A autorização irá expirar em 90 dias, 
                                    caso sejam realizadas consultas após esse período, então será necessário realizar o aceite novamente. <a href="https://www.segfy.com/termos-de-uso/" target="_blank">Ler Política de Privacidade</a>
                                </label>
                                <div class="error-message" v-if="errors.has('chkConsentimento2')">{{ errors.first('chkConsentimento2') }}</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios'

    export default {
        props: {customer:Object},
        computed: {
            // document: {
            //     get(){
            //         return this.$store.state.CustomerNew.document
            //     },
            //     set(value){
            //         this.$store.commit('CustomerNew/updateDocument', value)
            //     }
            // },
            // name: {
            //     get(){
            //         return this.$store.state.CustomerNew.name
            //     },
            //     set(value){
            //         this.$store.commit('CustomerNew/updateName', value)
            //     }
            // },
            // email: {
            //     get(){
            //         return this.$store.state.CustomerNew.email
            //     },
            //     set(value){
            //         this.$store.commit('CustomerNew/updateEmail', value)
            //     }
            // },
            // phone: {    
            //     get(){
            //         return this.$store.state.CustomerNew.phone
            //     },
            //     set(value){
            //         this.$store.commit('CustomerNew/updatePhone', value)
            //     }
            // },
            // celPhone: {
            //     get(){
            //         return this.$store.state.CustomerNew.celPhone
            //     },
            //     set(value){
            //         this.$store.commit('CustomerNew/updateCelPhone', value)
            //     }
            // },
            contactValidate(){
                return this.$root.$options.config.contactValidate
            },
            quotation(){
                return this.$store.getters['quotation']
            }
        },
        watch: {
            'customer.document': function(document) {
                document = document.replace(/[^A-Za-z0-9]/g,'')
                if(document.length != 14)
                    return

                axios.post(this.$root.$options.config.environment.applicationUrlApiAutomation + '/api/enterprise/version/1.0/insured',
                    {
                        config: {
                            token: this.$root.$options.config.token
                        },
                        data: {
                            document: document
                        }
                    },{
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${this.$store.state.automationBearer}`
                        }
                    }
                ).then(response => {
                    this.setDados(response.data.data)
                })
            },
            quotation(quotation){
                if( ! quotation.data.data.customer )
                    return

                this.customer.document = quotation.data.data.customer.document || ''

                this.$nextTick(() => {
                    this.customer.name      = quotation.data.data.customer.name || ''
                    this.customer.email     = quotation.data.data.customer.email || ''
                    this.customer.phone     = quotation.data.data.customer.phone || ''
                    this.customer.celPhone  = quotation.data.data.customer.celPhone || ''
                })
            }
        },
        methods: {
            consultaCPF(e){
                let document  = e.target.value.replace(/\D/g,'')

                if(document.length != 11 && document.length != 14)
                    return

                let valueInSessionStorage = sessionStorage.getItem(document)

                if(valueInSessionStorage){
                    valueInSessionStorage = JSON.parse(valueInSessionStorage)

                    if(valueInSessionStorage.msg || valueInSessionStorage.erro){
                        this.addCpfError(valueInSessionStorage)
                        return
                    }

                    // this.$store.dispatch('CustomerNew/setUpdateCustomer', valueInSessionStorage)
                    this.setDados(valueInSessionStorage)
                    this.validateFields()

                    this.$root.$options.eventBus.$emit('updatedCustomer')

                    return
                }

                this.$store.dispatch('exibeMensagemCarregamento', 'Aguarde, buscando dados...')

                this.$http.get(this.$root.$options.config.environment.applicationUrl + '/propostas/consulta_cpf', {
                    params: {
                        cpf: document
                    },
                    timeout: 10000
                }).then(response => {
                    this.$store.dispatch('closeLoading', 1000)

                    sessionStorage.setItem(document, JSON.stringify(response.body))

                    if(response.body.msg || response.body.erro){
                        this.addCpfError(response.body)
                        return
                    }

                    // this.$store.dispatch('CustomerNew/setUpdateCustomer', response.body)
                    this.setDados(response.body)
                    this.validateFields()

                    this.$root.$options.eventBus.$emit('updatedCustomer')
                }).catch(err => {
                    this.$store.dispatch('exibeMensagemCarregamento', 'Não foi possível buscar dados pelo CPF/CNPJ. Por favor, preencha os dados manualmente')
                    this.$store.dispatch('closeLoading', 3000)
                })
            },
            validateFields(){
                this.$nextTick(() => {
                    this.$validator.validate('data[customer][name]', this.customer.name)
                    this.$validator.validate('data[customer][document]', this.customer.document)
                })
            },
            addCpfError(value){
                this.errors.add('data[customer][document]', (value.msg || value.erro), 'cpfError')
            },
            setDados(dados){
                this.customer.name          = dados.name
                this.customer.email         = dados.email
                this.customer.phone         = dados.phone
                this.customer.celPhone      = dados.celPhone
            },
            resetCustomer(){
                this.customer.name   = ''
            }
        }
    }
</script>



// WEBPACK FOOTER //
// FormPartialCustomer.vue?57350396